/* eslint-disable */
// TODO refactor for each, etc

import {config} from '@shared/_services/config';
import {authHeader, handleResponse} from '@shared/_helpers';
import {FETCH_ALL_ROLES_SUCCESS, FETCH_DIAMOND_USERS_SUCCESS} from "./mutationTypes";
import UserDiamondApi from "@shared/_api/userDiamond";

const state = {
    diamondLoaded: false,
    diamond: []
};

const getters = {
    contacts: (state) => {
        let res = [];
        if (state.diamond && state.diamond.length > 0) {
            res = state.diamond.map(contact => {
                return Object.assign(contact, {label: ((contact.firstName) ? contact.firstName + " " : '') + contact.lastName + " (" + contact.company.companyName + ")"});
            })
        }
        return res;
    }
};

const actions = {
    fetchDiamond({commit}) {
        UserDiamondApi.fetchAll().then(diamondUsers => {
            commit(FETCH_DIAMOND_USERS_SUCCESS, diamondUsers)
        })
            .catch(error => {
                console.log(error)
            });
    },
};

const mutations = {
    [FETCH_DIAMOND_USERS_SUCCESS](state, diamondUsers) {
        state.diamondLoaded = true;
        state.diamond = diamondUsers;
    }
};

export const diamondManagement = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};